import clsx from 'clsx';
import { Parameter } from '../api';
import { COLS_FULL } from './columns';

export const ParameterRow = (ps: { parameter: Parameter }) => {
  return (
    <tr className="group">
      {COLS_FULL.map((col, i) => (
        <td
          key={i}
          className={clsx(
            'py-5 px-3 border-b group-even:bg-neutral-100',
            col.truncate &&
              'text-ellipsis max-w-1 overflow-hidden whitespace-nowrap',
          )}>
          {col.cell ? col.cell(ps.parameter) : ps.parameter[col.key]}
        </td>
      ))}
    </tr>
  );
};
